export enum Locations {
	Content = 'content',
	Checkout = 'checkout',
	Footer = 'footer',
	Header = 'header',
	Browser = 'browser'
}
